import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
// Components
import ProfilePicker from './ProfilePicker'

class AuthenticatedNav extends Component {

  state = {
    userIsViewingBackend: false,
  }

  componentDidMount() {
    if (
      this.isRoot() ||
      this.isActive('/locker') ||
      this.isActive('/settings')
    ) {
      this.setState({
        userIsViewingBackend: true
      })
    }
  }

  isActive(desiredPath) {
    const { path } = this.props
    let pathLength = desiredPath.length

    if (path.substring(0, pathLength) === desiredPath ) {
      return true
    } else {
      return false
    }
  }

  isRoot() {
    const { path } = this.props
    return path.length === 1
  }

  renderUserInitial = (user) => {
    return user.first_name.charAt(0)
  }

  renderAdminLinks() {
    return (
      <ul className="nav-authenticated-primary">
        <li>
          <Link
            to="/"
            className={this.isRoot() ? 'active' : ''}
          >
            Dashboard
          </Link>
        </li>
        <li>
          <Link
            to="/admin/profiles"
            className={this.isActive('/admin') ? 'active' : ''}
          >
            Admin
          </Link>
        </li>
      </ul>
    )
  }

  renderPrimaryNavLinks() {
    const { participations } = this.props.activeProfile

    if (participations) {
      return this.isOnboardedAndLoggedIn()
      ? (
        <ul className="nav-authenticated-primary">
          <li>
            <Link
              to="/"
              className={this.isRoot() ? 'active' : ''}
            >
              Dashboard
            </Link>
          </li>
          { participations[0].sport_slug &&
            <li>
              <Link
                to={`/locker/${participations[0].sport_slug}/profile`}
                className={this.isActive('/locker') ? 'active' : ''}
              >
                Locker
              </Link>
            </li>
          }
        </ul>
      ) : null
    }
  }

  renderSecondaryNavLinks() {
    const { userIsViewingBackend } = this.state
    const { trial_info } = this.props.activeProfile;

    return (
      <div className="nav-authenticated-secondary">
        {trial_info && this.renderUpgradeButton()}
        { userIsViewingBackend &&
          <ProfilePicker />
        }
        <div className="profile-account-container">
          {this.renderViewProfileButton()}
          {this.renderAccountButton()}
        </div>
      </div>
    )
  }

  renderUpgradeButton() {
    const { on_trial, days_remaining } = this.props.activeProfile.trial_info;

    const trialMessage = () => {
      if(days_remaining === 1) {
        return ('1 Day Left In Free Trial')
      } else if(days_remaining > 0) {
        return (`${days_remaining} Days Left In Free Trial`)
      } else {
        return ('Trial Expired')
      }
    }

    if ( on_trial ) {
      return (
        <div className="upgrade-button-container">
          <div className="trial-period-container">
              <svg><use xlinkHref="#clock" /></svg>
              <div className="trial-period-message">{trialMessage()}</div>
          </div>
          <Link
            to='/settings/payment-info/subscribe'
            className="cta cta-gradient upgrade-button"
            title="Upgrade Now"
          >
            Upgrade Now
          </Link>
        </div>
      )
    }
  }

  renderViewProfileButton() {
      const { username, participations, suspended } = this.props.activeProfile
      const { maintained_profiles } = this.props.user

      const notViewingMaintainedProfile = maintained_profiles.filter((profile) => {
        return this.isActive(`/${profile.username}`);
      }).length > 0 ? false : true

      if (suspended) {
        return (
          <div className="suspended-account-button">
            <span>Profile Suspended</span>
          </div>
        )
      }

      if (participations && notViewingMaintainedProfile) {
        return participations[0].sport_slug
        ? (
          <Link
            to={`/${username}/${participations[0].sport_slug}/profile`}
            className="cta view-profile-button"
            title="View Public Profile"
          >
            View Public Profile
          </Link>
        ) : null
      }
    }

  renderAccountButton() {
    const { user } = this.props

    let initialButton = this.isOnboardedAndLoggedIn()
    ? (
      <Link
        className="account-button"
        title="Account Settings"
        to="/settings/"
      >
        <div className="initial">
          <span className="initial-inner">
            {this.renderUserInitial(user)}
          </span>
        </div>
        <span className="account-button-text">
          My Account
        </span>
      </Link>
    )
    : (
      <div
        className="initial"
      >
        <span className="initial-inner">
          {this.renderUserInitial(user)}
        </span>
      </div>
    )

    return initialButton
  }

  isOnboardedAndLoggedIn() {
    const { user, activeProfile } = this.props

    if (
      user.maintained_profiles.length > 0 &&
      user.reduxLogInComplete &&
      activeProfile.participations
    ) {
      return true
    } else {
      return false
    }
  }

  isOnboarding() {
    const { user } = this.props

    return user.isOnboarding
  }

  render() {
    const { menuIsOpen, activeProfile } = this.props
    const { role } = this.props.user

    const userIsAdmin = role === 'admin' || role === 'super admin' ? true : false

    const activeProfileHasParticipations = activeProfile.participations ? activeProfile.participations.length > 0
    : false

    return (
      <nav className={`nav-authenticated menu-drawer${menuIsOpen ? '' : ' hidden'}`}>
        {userIsAdmin && this.renderAdminLinks()}
        {!userIsAdmin && activeProfileHasParticipations &&this.renderPrimaryNavLinks()}
        {!userIsAdmin && activeProfileHasParticipations && this.renderSecondaryNavLinks()}
      </nav>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    activeProfile: state.activeProfile
  }
}
export default connect(
  mapStateToProps,
  null
)(AuthenticatedNav)



// WEBPACK FOOTER //
// ./src/components/Global/AuthenticatedNav.js